import { createFileRoute, Outlet } from "@tanstack/react-router";

import { AppLayout } from "../components/AppLayout";
import { AppSettingsProvider } from "../lib/appSettings";
import { isRouteAllowed } from "../lib/routePermissions";
import { useRoleStore } from "../state/roleStore";

/**
 * Layout route for the authenticated admin app. Anything under this
 * pathless segment renders inside `AppLayout` (sidebar + topbar + main).
 *
 * The `beforeLoad` guard checks the target path against the route
 * permission map and redirects to the dashboard when the active role
 * lacks the required permission(s). Using window.location.replace
 * (rather than a client-side router redirect) is intentional — it
 * prevents back-button navigation to the denied page and works
 * regardless of TanStack Router version quirks.
 */
export const Route = createFileRoute("/_app")({
  beforeLoad: ({ location }: { location: { pathname: string } }) => {
    const { permissions } = useRoleStore.getState();
    if (!isRouteAllowed(location.pathname, permissions)) {
      window.location.replace("/");
    }
  },
  component: AppShell,
});

function AppShell() {
  return (
    <AppSettingsProvider>
      <AppLayout>
        <Outlet />
      </AppLayout>
    </AppSettingsProvider>
  );
}
